import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Ranking from "../pages/ranking/page";
import Detail from "../pages/detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fenlei",
    element: <Category />,
  },
  {
    path: "/paihang",
    element: <Ranking />,
  },
  {
    path: "/manhua/:id",
    element: <Detail />,
  },
  {
    path: "/guanyu",
    element: <About />,
  },
  {
    path: "/lianxi",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;